import { getStoreLinkRecord } from "winslow-core";
import { PromptPair } from "./Wazawan";
import "./WazawanQandAPreview.css";
import { LinkRecordActivity } from "../shares/LinkRecordActivity";
import { useSelector } from "react-redux";
import { selectEditingCollection } from "../../redux/features/appData";
import { showdownConverter } from "winslow-core";

type WazawanQandAPreviewProps = {
  promptPair: PromptPair;
  onExpand: (promptPair: PromptPair) => void;
};

export const WazawanQandAPreview = ({
  promptPair,
  onExpand,
}: WazawanQandAPreviewProps) => {
  const currentCollection = useSelector(selectEditingCollection);

  console.log("[WazawanQandAPreview] promptPair: ", promptPair);

  const response = JSON.parse(promptPair.response);
  const linkRecordIds = response.linkRecordIds;
  const linkRecords = currentCollection?.linkRecords || [];

  console.log("[WazawanQandAPreview] linkRecordsIds: ", linkRecordIds);
  return (
    <div
      className="wazawan-q-and-a-preview"
      onClick={() => onExpand(promptPair)}>
      {linkRecords && linkRecordIds && linkRecordIds.length > 0 && (
        <>
          {/* <div className="wazawan-q-and-a-preview-label">
                        Sources
                    </div> */}

          {linkRecordIds.map((lrId: string) => {
            if (!linkRecords) {
              return <></>;
            }

            const linkRecord = getStoreLinkRecord(lrId, linkRecords);

            if (!linkRecord) {
              return <></>;
            }

            return (
              <>
                {linkRecord && (
                  <LinkRecordActivity
                    key={lrId}
                    linkRecord={linkRecord}
                    minimum={true}
                    showDrag={false}
                    clickIsOpen={true}
                  />
                )}
              </>
            );
          })}
        </>
      )}

      {/* <div className="wazawan-q-and-a-preview-question">
                {promptPair.prompt}
            </div> */}
      <div className="wazawan-q-and-a-preview-answer">
        <div
          className="wazawan-answer-content"
          dangerouslySetInnerHTML={{
            __html: showdownConverter.makeHtml(response.answer),
          }}
        />
        {/* {response.answer} */}
      </div>
    </div>
  );
};
